<template>
    <div class="ranks">
        <div class="head">
            <div class="icon-name">排行榜</div>
            <div class="title">{{ rankData.name }}</div>
            <a :href="'/rank/info/' + rankData.nameEn | hostBuild('info')" class="more-link">查看更多&gt;</a>
        </div>
        <ul class="info-list">
            <li v-for="(item, index) in rankData.items" :key="item.id">
                <a :href="`/${item.topics[0].businessType.name_en}/${item.topics[0].englishName}/${item.merchantId||item.postId}` | hostBuild('info')" class="cover-img" target="_blank">
                    <div class="top-icon">
                        <img :src="require('@/assets/images/info/rank-0' + (index + 1) + '.png')" alt="" v-if="item.rank < 9"
                            width="44">
                        <img :src="require('@/assets/images/info/rank-10.png')" alt="" v-if="index == 9" width="44">
                    </div>
                    <img :src="item.logo || item.coverImage" alt="">
                </a>
                <a :href="`/${item.topics[0].businessType.name_en}/${item.topics[0].englishName}/${item.merchantId||item.postId}` | hostBuild('info')" target="_blank" class="title">
                    <!-- {{ item.shopCnName }}
                    {{ item.title }} -->
                    <span v-if="item.shopCnName && item.shopEnName">{{ item.shopCnName }} ({{ item.shopEnName }}) </span>
                    <span v-else-if="item.shopCnName">{{ item.shopCnName }} </span>
                    <span v-else-if="item.shopEnName">{{ item.shopEnName }} </span>
                    <span v-if="item.shopCnName != item.title">{{ item.title }}</span>
                </a>
                <div class="reason" v-if="item.description">{{ item.description }}</div>

                <div class="subf-info" v-if="item.gstars > 0">
                    <div class="pice" v-if="item.gstars > 0"><span>{{ item.gstars }}</span>评分</div>
                    <!-- <div class="pice"><span>{{item.postcode}}</span>条评论</div> -->
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'RankCategoryItem',
    props: ['rankData'],
    data() {
        return {

        }
    },
    
}
</script>
<style lang="scss" scoped>
.ranks {
    width: 720px;
    margin: 20px auto 0;
    background: #fff;
    padding: 20px 30px;
    box-sizing: border-box;
    border-radius: 10px;

    .head {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .icon-name {
            font-size: 14px;
            line-height: 24px;
            padding: 0 5px;
            background: #ff0000;
            color: #fff;
            border-radius: 2px;
            margin-right: 5px;
        }

        .title {
            flex: 1;
            font-size: 16px;
            font-weight: bold;
            
        }

        .more-link {
            font-size: 14px;
            color: #666;

            &:hover {
                color: #e43a3a;
            }
        }
    }

    .info-list {
        display: flex;
        margin: 0 -15px;

        li {
            flex: 1;
            overflow: hidden;
            padding: 0 15px;

            .cover-img {
                display: block;
                position: relative;
                font-size: 0;

                &:after {
                    position: relative;
                    content: '';
                    display: inline-block;
                    padding-bottom: 75%;
                }

                .top-icon {
                    position: absolute;
                    z-index: 2;
                    left: 0;
                    top: 0;
                    width: 44px;
                }

                >img {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .title {
                display: block;
                margin-top: 10px;
                font-size: 16px;
                color: #111;
                font-weight: bold;
                
                white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
              
            }

            .reason {
                margin-top: 10px;
                font-size: 14px;
                white-space: nowrap;
                color: #FE0000;
                overflow: hidden;
            }

            .subf-info {
                display: flex;
                margin-top: 10px;

                .pice {
                    margin-right: 20px;
                    color: #999;
                    font-size: 12px;

                    span {
                        color: #0065FE;
                    }
                }
            }
        }
    }
}
</style>